//modify ca before deploy!!!

export const APP_CONFIG = {
  // pot init amount in case the api is slow
  DAILY_POT: 6767,
  HOURLY_POT: 6767,
  
  // ca
  CONTRACT_ADDRESS: '0x1234567890abcdef1234567890abcdef12345678',
  
  // resp breakpoint (how wide screen has to be to go down to mobile version)
  DESKTOP_BREAKPOINT: 1024,
};

export const ROUTES = {
  HOME: '/',
  WINNERS: '/winners',
  ABOUT: '/about',
};